import React from 'react'
import TailLeft from './tail-left.svg'
import TailRight from './tail-right.svg'

export interface TailProps {
  my?: boolean
  className?: string
}

export const Tail = ({my, className}: TailProps) => {
  const Component = my ? TailRight : TailLeft
  return <Component className={className} />
}
